"use strict";import{IconVisibility as i}from"../src/elements/IconVisibility.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-visibility",i);
//# sourceMappingURL=sp-icon-visibility.js.map
